import React, { useEffect, useState } from 'react';
import { attackTexts } from '../contexts/LangHO2';

import initialaccessImg from '../assets/images/halcyon/initialaccess.png';
import remoteaccessImg from '../assets/images/halcyon/remoteaccess.png';
import privilegeImg from '../assets/images/halcyon/privilege.png';
import environmentenumerationImg from '../assets/images/halcyon/environmentenumeration.png';
import credentialharvestingImg from '../assets/images/halcyon/credentialharvesting.png';
import lateralmovementImg from '../assets/images/halcyon/lateralmovement.png';
import securitybypassImg from '../assets/images/halcyon/securitybypass.png';
import dataexfiltrationImg from '../assets/images/halcyon/dataexfiltration.png';
import backupdestructionImg from '../assets/images/halcyon/backupdestruction.png';
import dataencryptionImg from '../assets/images/halcyon/dataencryption.png';

function ProductHOAttack2({ lang = 'ko', isMobile = false }) {
  const [selected, setSelected] = useState('initialaccess'); // 선택된 단계 키 (초기값: 1번)
  const [animTick, setAnimTick] = useState(0); // 애니메이션 재생 트리거 카운터
  const [animProgress, setAnimProgress] = useState(1); // 0~1 애니메이션 진행도

  // 원형 클릭 시마다 선택 상태와 애니메이션 트리거 갱신
  const handleSelect = (key) => {
    setSelected(key);
    setAnimTick((t) => t + 1);
  };

  // 선택 변경 또는 트리거 변경 시 애니메이션 재시작
  useEffect(() => {
    let raf;
    const duration = 600; // ms
    const start = performance.now();
    setAnimProgress(0);
    const step = (now) => {
      const t = Math.min(1, (now - start) / duration);
      setAnimProgress(t);
      if (t < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => raf && cancelAnimationFrame(raf);
  }, [selected, animTick]);
  // 반 타원형 10분할 좌표 계산 (백분율 기준)
  const getSpot = (i) => {
    const cx = 50;   // 중심 X(%)
    const cy = isMobile ? 42 : 45;   // 중심 Y(%) - 바탕 안에 맞도록 조정 (35->42, 40->45)
    const a = isMobile ? 35 : 38;    // 가로 반경(%) - 모바일에서 축소
    const b = isMobile ? 35 : 38;    // 세로 반경(%) - 모바일에서 조정
    const t = Math.PI - (i - 1) * (Math.PI / 9); // i=1..10, 왼쪽→상단→오른쪽
    const x = cx + a * Math.cos(t);
    const y = cy - b * Math.sin(t);
    return { left: `${x.toFixed(2)}%`, top: `${y.toFixed(2)}%` };
  };

  const s1 = getSpot(1);   // initialaccess
  const s2 = getSpot(2);   // remoteaccess
  const s3 = getSpot(3);   // privilege
  const s10 = getSpot(10); // dataencryption
  const s9 = getSpot(9);   // backupdestruction
  const s8 = getSpot(8);   // dataexfiltration
  const s7 = getSpot(7);   // securitybypass
  const s6 = getSpot(6);   // lateralmovement
  const s5 = getSpot(5);   // credentialharvesting
  const s4 = getSpot(4);   // environmentenumeration

  // 선택된 단계의 제목+메시지 콘텐츠 구성
  const selectedTitle = selected ? attackTexts[selected]?.title?.[lang] : null;
  const selectedMessage = selected ? attackTexts[selected]?.message?.[lang] : null;
  const selectedContent = selected ? (
    <div style={{ padding: '12px 16px', textAlign: 'left' }}>
      <div style={{ fontWeight: 800, marginBottom: 8, color: '#F59E0B', textAlign: 'center', width: '100%' }}>
        {selectedTitle}
      </div>
      <div style={{ fontWeight: 500, lineHeight: 1.45 }}>
        {selectedMessage}
      </div>
    </div>
  ) : null;

  // 선택된 키 -> 해당 스팟 매핑
  const spotByKey = {
    initialaccess: s1,
    remoteaccess: s2,
    privilege: s3,
    environmentenumeration: s4,
    credentialharvesting: s5,
    lateralmovement: s6,
    securitybypass: s7,
    dataexfiltration: s8,
    backupdestruction: s9,
    dataencryption: s10,
  };
  const selectedSpot = selected ? spotByKey[selected] : null;

  return (
    <div
      style={{
        width: '100vw',
        maxWidth: '100vw',
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: 12,
        boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
        padding: isMobile ? '0 10px' : '0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start'
      }}
    >
      <span style={{
        fontSize: isMobile ? '1.7rem' : '2rem',
        fontWeight: 700,
        color: '#fff',
        marginBottom: isMobile ? 0 : 2,
        paddingLeft: isMobile ? 20 : 40,
        paddingTop: isMobile ? 20 : 28,
        display: 'block',
        lineHeight: 1.3,
        textAlign: 'center',
        width: '100%'
      }}>
        <br/>{attackTexts.title[lang]}
      </span>
      <div
        className="outline-flex"
        style={{
          display: 'flex',
          width: '100%',
          padding: isMobile ? '10px 20px 0 20px' : '6px 40px 0 40px',
          boxSizing: 'border-box',
          gap: isMobile ? 20 : 32,
          flexWrap: 'wrap',
          overflow: 'hidden'
        }}
      >
        {/* 반 타원형 배치 스테이지 */}
        <div
          style={{
            position: 'relative',
            width: '100%',
            aspectRatio: isMobile ? '5 / 5.5' : '1 / 0.9', // 조금만 줄임 (6->5.5, 1->0.9)
            maxWidth: isMobile ? 350 : 1400,
            margin: '0 auto',
            marginTop: isMobile ? 2 : 3,
            marginBottom: isMobile ? '10px' : '-25vw' // 간격 줄임
          }}
        >
          {/* 연결선: 선택된 노드만 주황색 애니메이션 선 표시 (회색 선 제거) */}
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
            style={{ 
              position: 'absolute', 
              left: 0, 
              top: 0, 
              zIndex: 0, 
              pointerEvents: 'none'
            }}
          >
            {/* 1번 원형과 문서 박스를 연결하는 회색 실선 */}
            <line
              x1={parseFloat(s1.left)}
              y1={parseFloat(s1.top)}
              x2={50}
              y2={isMobile ? 85 : 45}
              stroke="#22C55E"
              strokeWidth="2"
              vectorEffect="non-scaling-stroke"
              strokeLinecap="round"
              opacity="0.95"
            />
            <line x1={parseFloat(s2.left)} y1={parseFloat(s2.top)} x2={50} y2={isMobile ? 85 : 45} stroke="#22C55E" strokeWidth="2" vectorEffect="non-scaling-stroke" strokeLinecap="round" opacity="0.95" />
            <line x1={parseFloat(s3.left)} y1={parseFloat(s3.top)} x2={50} y2={isMobile ? 85 : 45} stroke="#22C55E" strokeWidth="2" vectorEffect="non-scaling-stroke" strokeLinecap="round" opacity="0.95" />
            <line x1={parseFloat(s4.left)} y1={parseFloat(s4.top)} x2={50} y2={isMobile ? 85 : 45} stroke="#22C55E" strokeWidth="2" vectorEffect="non-scaling-stroke" strokeLinecap="round" opacity="0.95" />
            <line x1={parseFloat(s5.left)} y1={parseFloat(s5.top)} x2={50} y2={isMobile ? 85 : 45} stroke="#22C55E" strokeWidth="2" vectorEffect="non-scaling-stroke" strokeLinecap="round" opacity="0.95" />
            <line x1={parseFloat(s6.left)} y1={parseFloat(s6.top)} x2={50} y2={isMobile ? 85 : 45} stroke="#22C55E" strokeWidth="2" vectorEffect="non-scaling-stroke" strokeLinecap="round" opacity="0.95" />
            <line x1={parseFloat(s7.left)} y1={parseFloat(s7.top)} x2={50} y2={isMobile ? 85 : 45} stroke="#22C55E" strokeWidth="2" vectorEffect="non-scaling-stroke" strokeLinecap="round" opacity="0.95" />
            <line x1={parseFloat(s8.left)} y1={parseFloat(s8.top)} x2={50} y2={isMobile ? 85 : 45} stroke="#22C55E" strokeWidth="2" vectorEffect="non-scaling-stroke" strokeLinecap="round" opacity="0.95" />
            <line x1={parseFloat(s9.left)} y1={parseFloat(s9.top)} x2={50} y2={isMobile ? 85 : 45} stroke="#22C55E" strokeWidth="2" vectorEffect="non-scaling-stroke" strokeLinecap="round" opacity="0.95" />
            <line x1={parseFloat(s10.left)} y1={parseFloat(s10.top)} x2={50} y2={isMobile ? 85 : 45} stroke="#22C55E" strokeWidth="2" vectorEffect="non-scaling-stroke" strokeLinecap="round" opacity="0.95" />
            {/* 선택된 노드에는 주황색 애니메이션 라인 오버레이 (rAF 기반) */}
            {selected && selectedSpot && (() => {
              const sx = parseFloat(selectedSpot.left);
              const sy = parseFloat(selectedSpot.top);
              const ex = 50;
              const ey = isMobile ? 85 : 45;
              const x2 = sx + (ex - sx) * animProgress;
              const y2 = sy + (ey - sy) * animProgress;
              return (
                <line
                  key={`${selected}-${animTick}`}
                  x1={sx}
                  y1={sy}
                  x2={x2}
                  y2={y2}
                  stroke="#22C55E"
                  strokeWidth="2"
                  opacity="0.95"
                  vectorEffect="non-scaling-stroke"
                  strokeLinecap="round"
                />
              );
            })()}
          </svg>

          {/* 중앙 문서 박스 */}
          <div
            style={{
              position: 'absolute',
              left: '50%',
              top: isMobile ? '85%' : '45%', // 모바일에서 반구형과 간격 줄임
              transform: 'translate(-50%, -50%)'
            }}
          >
            {documentBox({ lang, content: selectedContent, isMobile })}
          </div>

          {/* 반 타원형을 따라 배치된 원형들 (1,2,3,10번 위치) */}
          <div onClick={() => handleSelect('initialaccess')} style={{ position: 'absolute', left: s1.left, top: s1.top, transform: 'translate(-50%, -50%)', cursor: 'pointer' }}>
            {initialaccess({ lang, isSelected: selected === 'initialaccess', isMobile })}
          </div>
          <div onClick={() => handleSelect('remoteaccess')} style={{ position: 'absolute', left: s2.left, top: s2.top, transform: 'translate(-50%, -50%)', cursor: 'pointer' }}>
            {remoteaccess({ lang, isSelected: selected === 'remoteaccess', isMobile })}
          </div>
          <div onClick={() => handleSelect('privilege')} style={{ position: 'absolute', left: s3.left, top: s3.top, transform: 'translate(-50%, -50%)', cursor: 'pointer' }}>
            {privilege({ lang, isSelected: selected === 'privilege', isMobile })}
          </div>
          <div onClick={() => handleSelect('environmentenumeration')} style={{ position: 'absolute', left: s4.left, top: s4.top, transform: 'translate(-50%, -50%)', cursor: 'pointer' }}>
            {environmentenumeration({ lang, isSelected: selected === 'environmentenumeration', isMobile })}
          </div>
          <div onClick={() => handleSelect('credentialharvesting')} style={{ position: 'absolute', left: s5.left, top: s5.top, transform: 'translate(-50%, -50%)', cursor: 'pointer' }}>
            {credentialharvesting({ lang, isSelected: selected === 'credentialharvesting', isMobile })}
          </div>
          <div onClick={() => handleSelect('lateralmovement')} style={{ position: 'absolute', left: s6.left, top: s6.top, transform: 'translate(-50%, -50%)', cursor: 'pointer' }}>
            {lateralmovement({ lang, isSelected: selected === 'lateralmovement', isMobile })}
          </div>
          <div onClick={() => handleSelect('securitybypass')} style={{ position: 'absolute', left: s7.left, top: s7.top, transform: 'translate(-50%, -50%)', cursor: 'pointer' }}>
            {securitybypass({ lang, isSelected: selected === 'securitybypass', isMobile })}
          </div>
          <div onClick={() => handleSelect('dataexfiltration')} style={{ position: 'absolute', left: s8.left, top: s8.top, transform: 'translate(-50%, -50%)', cursor: 'pointer' }}>
            {dataexfiltration({ lang, isSelected: selected === 'dataexfiltration', isMobile })}
          </div>
          <div onClick={() => handleSelect('backupdestruction')} style={{ position: 'absolute', left: s9.left, top: s9.top, transform: 'translate(-50%, -50%)', cursor: 'pointer' }}>
            {backupdestruction({ lang, isSelected: selected === 'backupdestruction', isMobile })}
          </div>
          <div onClick={() => handleSelect('dataencryption')} style={{ position: 'absolute', left: s10.left, top: s10.top, transform: 'translate(-50%, -50%)', cursor: 'pointer' }}>
            {dataencryption({ lang, isSelected: selected === 'dataencryption', isMobile })}
          </div>

        </div>
      </div>
      {/* 반응형 처리: 화면이 작아질 때 동영상이 아래로 내려오도록 */}
      <style>
        {`
          @media (max-width: 900px) {
            .outline-flex {
              flex-direction: column !important;
              gap: 24px !important;
            }
            /* 작은 화면에서 요소 크기 축소 */
            .outline-flex .doc-box { transform: scale(0.9); transform-origin: center; }
          }
        `}
      </style>
    </div>
  );
}


export default ProductHOAttack2;

function initialaccess({ lang, isSelected = false, isMobile = false }) {
  // 모바일에서 선택된 원형은 크게, 선택되지 않은 원형은 작게
  const mobileSize = isSelected ? 100 : 60;
  const desktopSize = 160;
  
  return (
    <div
      aria-label="Initial Access"
      style={{
        width: isMobile ? mobileSize : desktopSize,
        height: isMobile ? mobileSize : desktopSize,
        borderRadius: '50%',
        background: isSelected ? 'linear-gradient(135deg, #1EC8FF 0%, #7AF2FF 100%)' : '#022A45',
        boxShadow: '0 6px 20px rgba(0,0,0,0.25)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: isMobile ? (isSelected ? 12 : 6) : 16,
        color: isSelected ? '#00253A' : '#FFFFFF',
        fontWeight: 800,
        fontSize: isMobile ? (isSelected ? '0.8rem' : '0.6rem') : '1rem',
        lineHeight: 1.25,
        transition: 'all 0.3s ease', // 부드러운 크기 변화
        opacity: isMobile && !isSelected ? 0.7 : 1 // 선택되지 않은 것은 투명도 조정
      }}
    >
      <img
        src={initialaccessImg}
        alt={attackTexts.initialaccess.title[lang]}
        style={{
          maxWidth: isMobile ? '60%' : '70%',
          height: 'auto',
          objectFit: 'contain',
          marginBottom: isMobile ? 4 : 8,
          display: 'block',
          filter: isSelected ? 'brightness(0)' : 'none'
        }}
      />
      <span>{attackTexts.initialaccess.title[lang]}</span>
    </div>
  );
}

function remoteaccess({ lang, isSelected = false, isMobile = false }) {
  const mobileSize = isSelected ? 100 : 60;
  const desktopSize = 160;
  
  return (
    <div
      aria-label="Remote Access"
      style={{
        width: isMobile ? mobileSize : desktopSize,
        height: isMobile ? mobileSize : desktopSize,
        borderRadius: '50%',
        background: isSelected ? 'linear-gradient(135deg, #1EC8FF 0%, #7AF2FF 100%)' : '#022A45',
        boxShadow: '0 6px 20px rgba(0,0,0,0.25)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: isMobile ? (isSelected ? 12 : 6) : 16,
        color: isSelected ? '#00253A' : '#FFFFFF',
        fontWeight: 800,
        fontSize: isMobile ? (isSelected ? '0.8rem' : '0.6rem') : '1rem',
        lineHeight: 1.25,
        transition: 'all 0.3s ease',
        opacity: isMobile && !isSelected ? 0.7 : 1
      }}
    >
      <img
        src={remoteaccessImg}
        alt={attackTexts.remoteaccess.title[lang]}
        style={{
          maxWidth: isMobile ? '60%' : '70%',
          height: 'auto',
          objectFit: 'contain',
          marginBottom: isMobile ? 4 : 8,
          display: 'block',
          filter: isSelected ? 'brightness(0)' : 'none'
        }}
      />
      <span>{attackTexts.remoteaccess.title[lang]}</span>
    </div>
  );
}

function privilege({ lang, isSelected = false, isMobile = false }) {
  const mobileSize = isSelected ? 100 : 60;
  const desktopSize = 160;
  
  return (
    <div
      aria-label="Privilege Escalation"
      style={{
        width: isMobile ? mobileSize : desktopSize,
        height: isMobile ? mobileSize : desktopSize,
        borderRadius: '50%',
        background: isSelected ? 'linear-gradient(135deg, #1EC8FF 0%, #7AF2FF 100%)' : '#022A45',
        boxShadow: '0 6px 20px rgba(0,0,0,0.25)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: isMobile ? (isSelected ? 12 : 6) : 16,
        color: isSelected ? '#00253A' : '#FFFFFF',
        fontWeight: 800,
        fontSize: isMobile ? (isSelected ? '0.8rem' : '0.6rem') : '1rem',
        lineHeight: 1.25,
        transition: 'all 0.3s ease',
        opacity: isMobile && !isSelected ? 0.7 : 1
      }}
    >
      <img
        src={privilegeImg}
        alt={attackTexts.privilege.title[lang]}
        style={{
          maxWidth: isMobile ? '60%' : '70%',
          height: 'auto',
          objectFit: 'contain',
          marginBottom: isMobile ? 4 : 8,
          display: 'block',
          filter: isSelected ? 'brightness(0)' : 'none'
        }}
      />
      <span>{attackTexts.privilege.title[lang]}</span>
    </div>
  );
}

function environmentenumeration({ lang, isSelected = false, isMobile = false }) {
  return (
    <div
      aria-label="Environment Enumeration"
      style={{
        width: isMobile ? (isSelected ? 100 : 60) : 160,
        height: isMobile ? (isSelected ? 100 : 60) : 160,
        borderRadius: '50%',
        background: isSelected ? 'linear-gradient(135deg, #1EC8FF 0%, #7AF2FF 100%)' : '#022A45',
        boxShadow: '0 6px 20px rgba(0,0,0,0.25)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: isMobile ? (isSelected ? 12 : 6) : 16,
        color: isSelected ? '#00253A' : '#FFFFFF',
        fontWeight: 800,
        fontSize: isMobile ? (isSelected ? '0.8rem' : '0.6rem') : '1rem',
        lineHeight: 1.25,
        transition: 'all 0.3s ease',
        opacity: isMobile && !isSelected ? 0.7 : 1
      }}
    >
      <img
        src={environmentenumerationImg}
        alt={attackTexts.environmentenumeration.title[lang]}
        style={{
          maxWidth: isMobile ? '60%' : '70%',
          height: 'auto',
          objectFit: 'contain',
          marginBottom: isMobile ? 4 : 8,
          display: 'block',
          filter: isSelected ? 'brightness(0)' : 'none'
        }}
      />
      <span>{attackTexts.environmentenumeration.title[lang]}</span>
    </div>
  );
}

function credentialharvesting({ lang, isSelected = false, isMobile = false }) {
  return (
    <div
      aria-label="Credential Harvesting"
      style={{
        width: isMobile ? (isSelected ? 100 : 60) : 160,
        height: isMobile ? (isSelected ? 100 : 60) : 160,
        borderRadius: '50%',
        background: isSelected ? 'linear-gradient(135deg, #1EC8FF 0%, #7AF2FF 100%)' : '#022A45',
        boxShadow: '0 6px 20px rgba(0,0,0,0.25)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: isMobile ? (isSelected ? 12 : 6) : 16,
        color: isSelected ? '#00253A' : '#FFFFFF',
        fontWeight: 800,
        fontSize: isMobile ? (isSelected ? '0.8rem' : '0.6rem') : '1rem',
        lineHeight: 1.25,
        transition: 'all 0.3s ease',
        opacity: isMobile && !isSelected ? 0.7 : 1
      }}
    >
      <img
        src={credentialharvestingImg}
        alt={attackTexts.credentialharvesting.title[lang]}
        style={{
          maxWidth: '70%',
          height: 'auto',
          objectFit: 'contain',
          marginBottom: 8,
          display: 'block',
          filter: isSelected ? 'brightness(0)' : 'none'
        }}
      />
      <span>{attackTexts.credentialharvesting.title[lang]}</span>
    </div>
  );
}

function lateralmovement({ lang, isSelected = false, isMobile = false }) {
  return (
    <div
      aria-label="Lateral Movement"
      style={{
        width: isMobile ? (isSelected ? 100 : 60) : 160,
        height: isMobile ? (isSelected ? 100 : 60) : 160,
        borderRadius: '50%',
        background: isSelected ? 'linear-gradient(135deg, #1EC8FF 0%, #7AF2FF 100%)' : '#022A45',
        boxShadow: '0 6px 20px rgba(0,0,0,0.25)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: isMobile ? (isSelected ? 12 : 6) : 16,
        color: isSelected ? '#00253A' : '#FFFFFF',
        fontWeight: 800,
        fontSize: isMobile ? (isSelected ? '0.8rem' : '0.6rem') : '1rem',
        lineHeight: 1.25,
        transition: 'all 0.3s ease',
        opacity: isMobile && !isSelected ? 0.7 : 1
      }}
    >
      <img
        src={lateralmovementImg}
        alt={attackTexts.lateralmovement.title[lang]}
        style={{
          maxWidth: '70%',
          height: 'auto',
          objectFit: 'contain',
          marginBottom: 8,
          display: 'block',
          filter: isSelected ? 'brightness(0)' : 'none'
        }}
      />
      <span>{attackTexts.lateralmovement.title[lang]}</span>
    </div>
  );
}

function securitybypass({ lang, isSelected = false, isMobile = false }) {
  return (
    <div
      aria-label="Security Bypass"
      style={{
        width: isMobile ? (isSelected ? 100 : 60) : 160,
        height: isMobile ? (isSelected ? 100 : 60) : 160,
        borderRadius: '50%',
        background: isSelected ? 'linear-gradient(135deg, #1EC8FF 0%, #7AF2FF 100%)' : '#022A45',
        boxShadow: '0 6px 20px rgba(0,0,0,0.25)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: isMobile ? (isSelected ? 12 : 6) : 16,
        color: isSelected ? '#00253A' : '#FFFFFF',
        fontWeight: 800,
        fontSize: isMobile ? (isSelected ? '0.8rem' : '0.6rem') : '1rem',
        lineHeight: 1.25,
        transition: 'all 0.3s ease',
        opacity: isMobile && !isSelected ? 0.7 : 1
      }}
    >
      <img
        src={securitybypassImg}
        alt={attackTexts.securitybypass.title[lang]}
        style={{
          maxWidth: '70%',
          height: 'auto',
          objectFit: 'contain',
          marginBottom: 8,
          display: 'block',
          filter: isSelected ? 'brightness(0)' : 'none'
        }}
      />
      <span>{attackTexts.securitybypass.title[lang]}</span>
    </div>
  );
}

function dataexfiltration({ lang, isSelected = false, isMobile = false }) {
  return (
    <div
      aria-label="Data Exfiltration"
      style={{
        width: isMobile ? (isSelected ? 100 : 60) : 160,
        height: isMobile ? (isSelected ? 100 : 60) : 160,
        borderRadius: '50%',
        background: isSelected ? 'linear-gradient(135deg, #1EC8FF 0%, #7AF2FF 100%)' : '#022A45',
        boxShadow: '0 6px 20px rgba(0,0,0,0.25)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: isMobile ? (isSelected ? 12 : 6) : 16,
        color: isSelected ? '#00253A' : '#FFFFFF',
        fontWeight: 800,
        fontSize: isMobile ? (isSelected ? '0.8rem' : '0.6rem') : '1rem',
        lineHeight: 1.25,
        transition: 'all 0.3s ease',
        opacity: isMobile && !isSelected ? 0.7 : 1
      }}
    >
      <img
        src={dataexfiltrationImg}
        alt={attackTexts.dataexfiltration.title[lang]}
        style={{
          maxWidth: isMobile ? (isSelected ? '65%' : '55%') : '70%',
          height: 'auto',
          objectFit: 'contain',
          marginBottom: isMobile ? (isSelected ? 6 : 3) : 8,
          display: 'block',
          filter: isSelected ? 'brightness(0)' : 'none'
        }}
      />
      <span>{attackTexts.dataexfiltration.title[lang]}</span>
    </div>
  );
}

function backupdestruction({ lang, isSelected = false, isMobile = false }) {
  return (
    <div
      aria-label="Backup Destruction"
      style={{
        width: isMobile ? (isSelected ? 100 : 60) : 160,
        height: isMobile ? (isSelected ? 100 : 60) : 160,
        borderRadius: '50%',
        background: isSelected ? 'linear-gradient(135deg, #1EC8FF 0%, #7AF2FF 100%)' : '#022A45',
        boxShadow: '0 6px 20px rgba(0,0,0,0.25)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: isMobile ? (isSelected ? 12 : 6) : 16,
        color: isSelected ? '#00253A' : '#FFFFFF',
        fontWeight: 800,
        fontSize: isMobile ? (isSelected ? '0.8rem' : '0.6rem') : '1rem',
        lineHeight: 1.25,
        transition: 'all 0.3s ease',
        opacity: isMobile && !isSelected ? 0.7 : 1
      }}
    >
      <img
        src={backupdestructionImg}
        alt={attackTexts.backupdestruction.title[lang]}
        style={{
          maxWidth: isMobile ? (isSelected ? '65%' : '55%') : '70%',
          height: 'auto',
          objectFit: 'contain',
          marginBottom: isMobile ? (isSelected ? 6 : 3) : 8,
          display: 'block',
          filter: isSelected ? 'brightness(0)' : 'none'
        }}
      />
      <span>{attackTexts.backupdestruction.title[lang]}</span>
    </div>
  );
}

function dataencryption({ lang, isSelected = false, isMobile = false }) {
  return (
    <div
      aria-label="Data Encryption"
      style={{
        width: isMobile ? (isSelected ? 100 : 60) : 160,
        height: isMobile ? (isSelected ? 100 : 60) : 160,
        borderRadius: '50%',
        background: isSelected ? 'linear-gradient(135deg, #1EC8FF 0%, #7AF2FF 100%)' : '#022A45',
        boxShadow: '0 6px 20px rgba(0,0,0,0.25)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: isMobile ? (isSelected ? 12 : 6) : 16,
        color: isSelected ? '#00253A' : '#FFFFFF',
        fontWeight: 800,
        fontSize: isMobile ? (isSelected ? '0.8rem' : '0.6rem') : '1rem',
        lineHeight: 1.25,
        transition: 'all 0.3s ease',
        opacity: isMobile && !isSelected ? 0.7 : 1
      }}
    >
      <img
        src={dataencryptionImg}
        alt={attackTexts.dataencryption.title[lang]}
        style={{
          maxWidth: isMobile ? (isSelected ? '65%' : '55%') : '70%',
          height: 'auto',
          objectFit: 'contain',
          marginBottom: isMobile ? (isSelected ? 6 : 3) : 8,
          display: 'block',
          filter: isSelected ? 'brightness(0)' : 'none'
        }}
      />
      <span>{attackTexts.dataencryption.title[lang]}</span>
    </div>
  );
}

// 고정 크기 직사각형 박스
function documentBox({ lang, content, isMobile = false }) {
  return (
    <div
      className="doc-box"
      style={{
        width: isMobile ? 280 : 540,
        height: isMobile ? 120 : 160,
        borderRadius: 12,
        background: '#022A45',
        boxShadow: '0 6px 20px rgba(0,0,0,0.25)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        color: '#FFFFFF',
        fontWeight: 700,
        fontSize: isMobile ? '0.85rem' : '1rem',
        border: '1px solid #F59E0B'
      }}
    >
      {content ? (
        <div style={{ 
          padding: isMobile ? '8px 12px' : '12px 16px', 
          fontWeight: 500, 
          lineHeight: 1.45 
        }}>
          {content}
        </div>
      ) : (
        <span>Document</span>
      )}
    </div>
  );
}
